import AuthorizePayment from '../AuthorizePayment';
import IPGPayment from '../IPGPayment';
import BamboraPayment from '../BamboraPayment';
import { useDonationStore } from '../libs/useDonationStore';
import { CREDIT_CARD_PROVIDER, PAYMENT_TYPE } from '../libs/common';
import InlineMessage from '3-components/InlineMessage/InlineMessage';
import DebitPayment from '../DebitPayment';
import PrivacyLink from '../components/PrivacyLink';
import CheckoutPaymentIcons from './CheckoutPaymentIcons';
import { useDonationBlockProps } from '../DonationBlockProvider';
import DonationGiftTile from '../components/DonationGIftTile';
import DonationSummaryBox from '../DonationForm/DonationSummaryBox';
import PayfurlPayment from '../PayfurlPayment';
import Icon from '2-core-elements/Icon/Icon';

const PaymentForm = (): JSX.Element => {
    const { donationData: { payment } } = useDonationStore();
    const { paymentPageIntro, giftTileSettings, labels } = useDonationBlockProps();

    if (!payment) {
        return (
            <div>
                <InlineMessage status="error">
                    No payment selected. Please reload the page.
                </InlineMessage>
            </div>
        );
    }

    const isDirectDebitPayment = payment === PAYMENT_TYPE.DIRECT_DEBIT;
    const isPayfurlPayment = payment === CREDIT_CARD_PROVIDER.payFURL;
    const isEmptyContentHeader = !labels?.paymentStepTitle && !labels?.paymentStepSubtitle;

    return (
        <div className="donation-payment-wrapper">
            {!isEmptyContentHeader && (
                <div className="donation-payment-intro">
                    {labels?.paymentStepTitle && (
                        <div className="donation-payment-intro-title">
                            {labels.paymentStepTitle}
                        </div>
                    )}
                    {labels?.paymentStepSubtitle && (
                        <div className="donation-payment-intro-description">
                            <div className="icon-box"><Icon icon={'lock-filled'} /></div>
                            <div className="intro-blurb">{labels.paymentStepSubtitle}</div>
                        </div>
                    )}
                </div>
            )}
            {giftTileSettings?.enable && (
                <div className="donation-payment-gifttile">
                    <DonationGiftTile />
                </div>
            )}
            <div className="donation-payment-header">
                <CheckoutPaymentIcons />
                {paymentPageIntro && (
                    <div className="donation-payment-header-text">
                        {paymentPageIntro}
                    </div>
                )}
            </div>

            {!isDirectDebitPayment && (
                <div className="donation-payment-iframe-wrapper">
                    {payment === CREDIT_CARD_PROVIDER.AuthorizeNet && (
                        <AuthorizePayment />
                    )}

                    {payment === CREDIT_CARD_PROVIDER.Bambora && (
                        <BamboraPayment />
                    )}

                    {payment === CREDIT_CARD_PROVIDER.IPG && (
                        <IPGPayment />
                    )}

                    {payment === CREDIT_CARD_PROVIDER.payFURL && (
                        <PayfurlPayment />
                    )}
                </div>
            )}

            {isDirectDebitPayment && (
                <DebitPayment />
            )}

            {!isDirectDebitPayment && !isPayfurlPayment && (
                <div className="payment-summary-block">
                    <DonationSummaryBox />
                </div>
            )}

            <PrivacyLink />
        </div>
    );
};

export default PaymentForm;
